import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getQuickPricing } from '../../state/services/extraService';
import { debounce } from '../../commons/browser';
import LoadingOverlay from 'react-loading-overlay';
import Select from 'react-select';
import { join } from 'lodash';
import moment from 'moment-timezone';
import { getAddressesWithPrefix } from '../../state/services/elasticsearchService';
import { setQuickQuoteBookingData } from '../../state/actions/bookingActions';

import 'react-datepicker/dist/react-datepicker.css';
import { Button, Popover, PopoverBody, UncontrolledTooltip } from 'reactstrap';
import { toast } from 'react-toastify';
import { resetQuickPricings, setErrorMessage } from '../../state/actions/extraActions';
// import { getCurrentSubdomain } from '../../commons/domain';
import ExtremelyLargeItemAlertModal from '../CommonModals/ExtremelyLargeItemAlertModal';
import { hasLargeItem } from '../../commons/validations';
import { sortByPostalCodeAndSuburb } from '../../commons/addresses';

import { saveBooking } from '../../state/services/bookingService';
import { v4 as uuid } from 'uuid';
import ConfirmModal from '../CommonModals/ConfirmModal';
import { isGWSubClientWithId } from '../../commons/helpers';

class QuickQuotePopover extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            findKeyword: '',
            isOpenQuickQuote: false,
            isGettingQuickQuote: false,
            activeTabInd: 0,
            customer: { value: '' },
            puSuburb: { value: '' },
            deToSuburb: { value: '' },
            formInputs: {
                pu_Address_State: '',
                pu_Address_PostalCode: '',
                pu_Address_Suburb: '',
                de_To_Address_State: '',
                de_To_Address_PostalCode: '',
                de_To_Address_Suburb: '',
                customer_id: '',
                pu_Address_Type : 'business',
                b_booking_tail_lift_pickup : '0',
                pu_no_of_assists : '0',
                de_To_AddressType : 'business',
                b_booking_tail_lift_deliver : '0',
                de_no_of_assists : '0',
                insurance_service : false,
                client_sales_total : null
            },
            lines: [
                {
                    e_qty: '',
                    e_dimUOM: 'm',
                    e_dimLength: '',
                    e_dimWidth: '',
                    e_dimHeight: '',
                    e_weightUOM: 'kg',
                    e_weightPerEach: '',
                    e_type_of_packaging: 'carton',
                    packed_status: 'original',
                }
            ],
            isInvalid : false,
            extraLargeItemModal: false,
            preValue: {
                pu_Address_Type: '',
                de_To_AddressType: '',
                b_booking_tail_lift_pickup: '',
                b_booking_tail_lift_deliver: ''
            },
            isShowConfirmModal: false,
            selectedPricing: null
        };
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        setIsOpen: PropTypes.func.isRequired,
        clientname: PropTypes.string,
        dmeClients: PropTypes.array,
        quickPricings: PropTypes.array,
        quickPricingLines: PropTypes.array,
        puAddresses: PropTypes.array,
        deToAddresses: PropTypes.array,
        errorMessage: PropTypes.string,
        bookingErrorMessage: PropTypes.string,
        getAddressesWithPrefix: PropTypes.func.isRequired,
        getQuickPricing: PropTypes.func.isRequired,
        setErrorMessage: PropTypes.func.isRequired,
        setQuickQuoteBookingData: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        saveBooking: PropTypes.func.isRequired,
        booking: PropTypes.object,
        resetQuickPricings: PropTypes.func.isRequired
    };

    static defaultProps = {
        isOpen: false,
    };

    UNSAFE_componentWillReceiveProps(newProps) {
        const { isOpen, clientname, dmeClients, quickPricings, quickPricingLines, errorMessage, booking, bookingErrorMessage } = newProps;

        if (bookingErrorMessage && this.props.bookingErrorMessage !== bookingErrorMessage) {
            if(this.state.isGettingQuickQuote)
                this.notify(bookingErrorMessage);
            this.setState({ isGettingQuickQuote: false });
        }

        if (isOpen) {
            const { clientname, dmeClients } = this.props;
            const { customer } = this.state;
            if (dmeClients.length > 0 && (clientname !== 'dme' && clientname !== 'Gebrüder Weiss')) {
                if (customer.value !== dmeClients[0].pk_id_dme_client) {
                    this.handleChangeCustomer({ value: dmeClients[0].pk_id_dme_client });
                }
            }
        }

        if (isOpen) {
            if (errorMessage != '' && errorMessage !== this.props.errorMessage){
                toast.error(errorMessage);
                this.setState({ isGettingQuickQuote: false });
                this.props.setErrorMessage('');
            }
        }

        if (this.props.quickPricings !== quickPricings && quickPricings.length > 0) {
            this.setState({ isGettingQuickQuote: false, lines: quickPricingLines });
        }

        if (clientname)
            this.setState({ clientname });
        if (dmeClients && dmeClients.length === 1) // When logged in with the Client
            this.setState({ clientPK: dmeClients[0].pk_id_dme_client });
    
        if (this.props.isOpen && (booking && this.props.booking !== booking)) {
            // toast.success('Booking is created successfully.');
            this.props.setIsOpen(false);
            this.setState({ isGettingQuickQuote: false });
            this.toggleShowConfirmModal();
            // window.open('/booking?bookingId=' + booking.b_bookingID_Visual, '_blank');
            // window.focus();
        }
    }

    onInputChange(e, index, field) {
        const { lines } = this.state;
        const newlines = [...lines];
        newlines[index][field] = e.target.value;

        if (e.target.type === 'number') newlines[index][field] = parseFloat(newlines[index][field]);

        this.setState({ lines: newlines });
    }

    /*
     * @param {array<object>} addresses - address array from es(elasticsearch)
     * @param {string} mixedAddress - mixed address
     * @return {object} address - found address object
     */
    _findAddress = (addresses, mixedAddress) => {
        return addresses.find(address => {
            const fullAddress = `${address._source.suburb} ${address._source.postal_code} ${address._source.state}`;
            return fullAddress === mixedAddress;
        });
    };

    _findCustomer = (customers, value) => {
        return customers.find(customer => {
            return customer.pk_id_dme_client === value;
        });
    };

    onSwitchTab(e, activeTabInd) {
        e.preventDefault();
        this.setState({ activeTabInd });
    }

    handleChangeCustomer = (selectedOption) => {
        const { formInputs } = this.state;
        const { dmeClients } = this.props;

        const customerInfo = this._findCustomer(dmeClients, selectedOption.value);
        formInputs['customer_id'] = customerInfo.pk_id_dme_client;
        const customer = { label: customerInfo.company_name, value: customerInfo.pk_id_dme_client };
        this.setState({ customer, formInputs });
    };

    handleChangeSuburb = (selectedOption, src) => {
        const { formInputs } = this.state;
        const { puAddresses, deToAddresses } = this.props;

        if (src === 'puSuburb') {
            const address = this._findAddress(puAddresses, selectedOption.value);
            formInputs['pu_Address_State'] = address._source.state;
            formInputs['pu_Address_PostalCode'] = address._source.postal_code;
            formInputs['pu_Address_Suburb'] = address._source.suburb;
            const puSuburb = { label: address._source.suburb, value: address._source.suburb };
            this.setState({ puSuburb, formInputs });
        } else if (src === 'deToSuburb') {
            const address = this._findAddress(deToAddresses, selectedOption.value);
            formInputs['de_To_Address_State'] = address._source.state;
            formInputs['de_To_Address_PostalCode'] = address._source.postal_code;
            formInputs['de_To_Address_Suburb'] = address._source.suburb;
            const deToSuburb = { label: address._source.suburb, value: address._source.suburb };
            this.setState({ deToSuburb, formInputs });
        }
    };

    handleInputChangeSuburb = (query, src) => {
        let postalCodePrefix = null;
        let suburbPrefixes = [];
        const iters = query.split(' ');
        iters.map((iter) => {
            if (!isNaN(iter))
                postalCodePrefix = iter;
            else
                suburbPrefixes.push(iter);
        });

        if (postalCodePrefix || suburbPrefixes.length > 0) {
            if (src === 'puSuburb') {
                this.props.getAddressesWithPrefix(
                    'puAddress',
                    join(suburbPrefixes, ' '),
                    postalCodePrefix
                );
            } else if (src === 'deToSuburb') {
                this.props.getAddressesWithPrefix(
                    'deToAddress',
                    join(suburbPrefixes, ' '),
                    postalCodePrefix
                );
            }

            this.setState({ suburbPrefix: join(suburbPrefixes, ' '), postalCodePrefix });
        }
    };

    handleFocusSuburb = (src) => {
        const { formInputs } = this.state;

        if (src === 'puSuburb') {
            this.props.getAddressesWithPrefix(
                'puAddress',
                formInputs['pu_Address_Suburb'] || 'syd',
                null
            );
        } else if (src === 'deToSuburb') {
            this.props.getAddressesWithPrefix(
                'deToAddress',
                formInputs['de_To_Address_Suburb'] || 'syd',
                null
            );
        }
    };

    onClickAddPackage() {
        const { lines } = this.state;
        const newlines = [...lines];
        newlines.unshift({
            e_qty: '',
            e_dimUOM: 'm',
            e_dimLength: '',
            e_dimWidth: '',
            e_dimHeight: '',
            e_weightUOM: 'kg',
            e_weightPerEach: '',
            e_type_of_packaging: 'carton',
            packed_status: 'original',
        });
        this.setState({ lines: newlines });
    }

    onCancel(index) {
        const { lines } = this.state;
        const newlines = [...lines];
        newlines.splice(index, 1);
        this.setState({ lines: newlines });
    }

    notify = (text) => toast(text);

    reflectPreValueToBooking = (formInputs, preValue) => {
        let booking = { ...formInputs };

        if (preValue['pu_Address_Type']){
            booking['pu_Address_Type'] = preValue['pu_Address_Type'];
        } else {
            booking['pu_Address_Type'] = 'business';
        }

        if (preValue['b_booking_tail_lift_pickup']){
            booking['b_booking_tail_lift_pickup'] = preValue['b_booking_tail_lift_pickup'];
        } else {
            booking['b_booking_tail_lift_pickup'] = '0';
        }

        if (preValue['de_To_AddressType']){
            booking['de_To_AddressType'] = preValue['de_To_AddressType'];
        } else {
            booking['de_To_AddressType'] = 'business';
        }

        if (preValue['b_booking_tail_lift_deliver']){
            booking['b_booking_tail_lift_deliver'] = preValue['b_booking_tail_lift_deliver'];
        } else {
            booking['b_booking_tail_lift_deliver'] = '0';
        }
        return booking;
    }

    onClickGetQuote(e) {
        e.preventDefault();

        if (!this.state.formInputs.customer_id) {
            this.notify('Please select Customer.');
            return;
        } else if (!this.state.formInputs.pu_Address_Suburb) {
            this.notify('Please select Pickup address.');
            return;
        } else if (!this.state.formInputs.de_To_Address_Suburb) {
            this.notify('Please select Delivery address.');
            return;
        } else if (this.state.formInputs.pu_Address_Suburb == this.state.formInputs.de_To_Address_Suburb) {
            this.notify('Pickup address and Delivery address are same!');
            return;
        } else if (!this.state.formInputs.pu_Address_Type) {
            this.setState({ isInvalid : true });
            this.notify('Please select Pickup address type.');

            return;
        } else if (!this.state.formInputs.de_To_AddressType) {
            this.setState({ isInvalid : true });
            this.notify('Please select Delivery address type.');
            return;
        } else if (!this.state.formInputs.pu_no_of_assists) {
            this.setState({ isInvalid : true });
            this.notify('Please select number of men to assist of Pickup.');
            return;
        } else if (!this.state.formInputs.de_no_of_assists) {
            this.setState({ isInvalid : true });
            this.notify('Please select number of men to assist of Delivery.');
            return;
        }

        const { preValue, formInputs } = this.state;
        
        formInputs['pk_booking_id'] = uuid();
        this.setState({formInputs: formInputs});

        const booking = this.reflectPreValueToBooking(formInputs, preValue);

        if (hasLargeItem(booking, this.state.lines)){
            this.setState({
                extraLargeItemModal: true
            });
            return;
        }

        this.setState({selectedPricing: null});

        this.props.getQuickPricing({
            'booking': booking,
            'booking_lines': this.state.lines,
            'clientId': this.state.customer.value,
        });
        this.setState({ isGettingQuickQuote: true });
    }

    copyToClipBoard = async text => {
        try {
            await navigator.clipboard.writeText(text);
            this.notify('Copied!');
        } catch (err) {
            this.notify('Failed to copy!');
        }
    };

    closeExtraLargeItemErrorModal = () => {
        this.setState({
            extraLargeItemModal: false
        });
    }

    handleChangeAddressTypePreValue = (e, type) => {
        const { preValue } = this.state;
        if (type == 'pu')
            preValue['pu_Address_Type'] = e.target.value;
        else
            preValue['de_To_AddressType'] =  e.target.value;
        this.setState({
            preValue
        });
    };

    handleChangeTailLiftPreValue = (e, type) => {
        const { preValue } = this.state;
        if (type === 'pu')
            preValue['b_booking_tail_lift_pickup'] = e.target.value;
        else
            preValue['b_booking_tail_lift_deliver'] = e.target.value;
        this.setState({
            preValue
        });
    };

    handleCreateBooking = () => {
        // const { setQuickQuoteBookingData, history, setIsOpen } = this.props;
        // const { formInputs, lines, preValue } = this.state;
        
        // setQuickQuoteBookingData({
        //     'booking': this.reflectPreValueToBooking(formInputs, preValue),
        //     'booking_lines': lines,
        // });
        // setIsOpen(false);
        // history.push('/create-a-booking');

        const { formInputs, lines, preValue, customer, selectedPricing } = this.state;
        if (!formInputs['pk_booking_id']){
            toast.warn('Please get the quote first.');
            return;
        }
        let booking = this.reflectPreValueToBooking(formInputs, preValue);
        booking['from_quick_quote'] = true;
        booking['client_id'] = customer.value;
        booking['selected_pricing'] = selectedPricing;
        this.setState({isGettingQuickQuote: true});
        this.props.saveBooking(booking, lines);
    }

    onClickConfirmBtn = () => {
        this.resetForm();
        this.toggleShowConfirmModal();
    }

    handleOnClickPricing = (price) => {
        this.setState({selectedPricing: price['cost_id']});
    }

    resetForm = () => {
        this.props.resetQuickPricings();
        this.setState({
            activeTabInd: 0,
            customer: { value: '' },
            puSuburb: { value: '' },
            deToSuburb: { value: '' },
            formInputs: {
                pu_Address_State: '',
                pu_Address_PostalCode: '',
                pu_Address_Suburb: '',
                de_To_Address_State: '',
                de_To_Address_PostalCode: '',
                de_To_Address_Suburb: '',
                customer_id: '',
                pu_Address_Type : 'business',
                b_booking_tail_lift_pickup : '0',
                pu_no_of_assists : '0',
                de_To_AddressType : 'business',
                b_booking_tail_lift_deliver : '0',
                de_no_of_assists : '0',
                insurance_service : false,
                client_sales_total : null
            },
            lines: [
                {
                    e_qty: '',
                    e_dimUOM: 'm',
                    e_dimLength: '',
                    e_dimWidth: '',
                    e_dimHeight: '',
                    e_weightUOM: 'kg',
                    e_weightPerEach: '',
                    e_type_of_packaging: 'carton',
                    packed_status: 'original',
                }
            ],
            isInvalid : false,
            preValue: {
                pu_Address_Type: '',
                de_To_AddressType: '',
                b_booking_tail_lift_pickup: '',
                b_booking_tail_lift_deliver: ''
            },
        });
    }

    onClickCancelBtn = () => {
        const { booking } = this.props;
        this.toggleShowConfirmModal();
        window.open('/booking?bookingId=' + booking.b_bookingID_Visual, '_blank');
        window.focus();
    }

    toggleShowConfirmModal = () => {
        this.setState(prevState => ({ isShowConfirmModal: !prevState.isShowConfirmModal }));
    }

    render() {
        const { isOpen, setIsOpen, dmeClients, quickPricings, clientname } = this.props;
        const { puSuburb, deToSuburb, formInputs, activeTabInd, lines, customer, isGettingQuickQuote, extraLargeItemModal, preValue, selectedPricing } = this.state;

        // const isGW = (
        //     getCurrentSubdomain().indexOf('gw') !== -1
        //     || localStorage.getItem('theme') === 'gw-theme'
        // );

        const clientOptionsList = dmeClients
            .map((client) => { return { label: client.company_name, value: client.pk_id_dme_client }; });
        const filteredLines = lines.filter(line => {
            if (activeTabInd == 0)
                return line['packed_status'] == 'original';
            else
                return line['packed_status'] == 'auto';
        });

        // Populate puAddresses and deToAddresses
        let puAddressOptions = [];
        let deToAddressOptions = [];
        if (formInputs['pu_Address_Suburb'] && this.props.puAddresses.length === 0) {
            const value = `${formInputs['pu_Address_Suburb']}`;
            puAddressOptions = [{ value: value, label: value }];
        } else if (this.props.puAddresses.length > 0) {
            puAddressOptions = sortByPostalCodeAndSuburb(this.props.puAddresses).map(address => {
                const value = `${address._source.suburb} ${address._source.postal_code} ${address._source.state}`;
                return { value: value, label: value };
            });
        }
        if (formInputs['de_To_Address_Suburb'] && this.props.deToAddresses.length === 0) {
            const value = `${formInputs['de_To_Address_Subfurb']}`;
            deToAddressOptions = [{ value: value, label: value }];
        } else if (this.props.deToAddresses.length > 0) {
            deToAddressOptions = sortByPostalCodeAndSuburb(this.props.deToAddresses).map(address => {
                const value = `${address._source.suburb} ${address._source.postal_code} ${address._source.state}`;
                return { value: value, label: value };
            });
        }

        const originalPricings = quickPricings
            .filter((price) => price.packed_status === 'original')
            .filter((price) => {
                if (clientname !== 'dme')
                    return price['fp_name'] !== 'MRL Sampson';
                return true;
            })
            .map((price, index) => {
                return (
                    <tr key={index} className={'pricing-row' + (selectedPricing === price['cost_id'] ? ' selected' : '')}>
                        <td>{price['fp_name']} ({price['account_code']})</td>
                        <td>{price['vehicle_name'] ? `${price['service_desc']} (${price['vehicle_name']})` : price['service_desc']}</td>
                        <td>
                            ${price['cost_dollar'].toFixed(2)}
                            &nbsp;&nbsp;&nbsp;
                            <i className="fa fa-copy" onClick={() => this.copyToClipBoard(price['cost_dollar'].toFixed(2))}></i>
                        </td>
                        <td>{(price['mu_percentage_fuel_levy'] * 100).toFixed(2)}%</td>
                        <td>${price['fuel_levy_base_cl'].toFixed(2)}</td>
                        <td>
                            ${price['surcharge_total_cl'].toFixed(2)}
                            {price['surcharge_total_cl'].toFixed(2) > 0
                                ? <React.Fragment>
                                    <i className="fa fa-dollar-sign" id={`surcharge_${index}`}></i>
                                    <UncontrolledTooltip
                                        className="surcharge-tooltip"
                                        placement="right"
                                        target={`surcharge_${index}`}
                                    >
                                        {
                                            price.surcharges.filter(surcharge => clientname === 'dme' || surcharge.visible)
                                                .map((surcharge, index) => {
                                                    const selectedSurchargeFor = 'client';
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <p className="surcharge">
                                                                <strong>Name:</strong> {surcharge['name']}<br />
                                                                <strong>Description:</strong> {surcharge['description']}<br />
                                                                <strong>Amount:</strong> {selectedSurchargeFor === 'dme' ? surcharge['amount'] : surcharge['amount_cl']}<br />
                                                                <strong>Qty:</strong> {surcharge['qty'] || 1}<br />
                                                                <strong>Manually added?:</strong> {surcharge['is_manually_entered'] ? 'Yes' : 'No'}<br />
                                                                {index !== 0 ? <hr/> : null}
                                                            </p>
                                                        </React.Fragment>
                                                    );
                                                })
                                        }
                                    </UncontrolledTooltip>
                                </React.Fragment>
                                : ''}
                        </td>
                        <td className='text-center'>{price['insurance_fee'] ? `$${price['insurance_fee'].toFixed(2)}` : ''}</td>
                        <td>
                            ${(price['client_mu_1_minimum_values'] * (1 + price['parent_markup_percent'])).toFixed(2)}
                            &nbsp;&nbsp;&nbsp;
                            <i className="fa fa-copy" onClick={() => this.copyToClipBoard((price['client_mu_1_minimum_values'] * (1 + price['parent_markup_percent'])).toFixed(2))}></i>
                        </td>
                        <td>{moment().add(Math.ceil(price['eta_in_hour'] / 24), 'd').format('YYYY-MM-DD')} ({price['eta']})</td>
                        <td>
                            <Button
                                className="btn-sm btn-icon m-auto"
                                color={selectedPricing === price['cost_id'] ? 'success' : 'primary'}
                                disabled={selectedPricing === price['cost_id']}
                                onClick={() => this.handleOnClickPricing(price)}
                            >
                                <i className='fa fa-check'/>
                            </Button>
                        </td>
                    </tr>
                );
            });

        const autoPricings = quickPricings
            .filter(pricing => pricing.packed_status === 'auto')
            .filter((price) => {
                if (clientname !== 'dme')
                    return price['fp_name'] !== 'MRL Sampson';
                return true;
            })
            .map((price, index) => {
                return (
                    <tr key={index} className={'pricing-row' + (selectedPricing === price['cost_id'] ? ' selected' : '')}>
                        <td>{price['fp_name']} ({price['account_code']})</td>
                        <td>{price['vehicle_name'] ? `${price['service_desc']} (${price['vehicle_name']})` : price['service_desc']}</td>
                        <td>
                            ${price['cost_dollar'].toFixed(2)}
                            &nbsp;&nbsp;&nbsp;
                            <i className="fa fa-copy" onClick={() => this.copyToClipBoard(price['cost_dollar'].toFixed(2))}></i>
                        </td>
                        <td>{(price['mu_percentage_fuel_levy'] * 100).toFixed(2)}%</td>
                        <td>${price['fuel_levy_base_cl'].toFixed(2)}</td>
                        <td>
                            ${price['surcharge_total_cl'].toFixed(2)} {price['surcharge_total_cl'].toFixed(2) > 0
                                ? <React.Fragment>
                                    <i className="fa fa-dollar-sign" id={`surcharge_${index}`}></i>
                                    <UncontrolledTooltip
                                        className="surcharge-tooltip"
                                        placement="right"
                                        target={`surcharge_${index}`}
                                    >
                                        {
                                            price.surcharges.filter(surcharge => clientname === 'dme' || surcharge.visible)
                                                .map((surcharge, index) => {
                                                    const selectedSurchargeFor = 'client';
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <p className="surcharge">
                                                                <strong>Name:</strong> {surcharge['name']}<br />
                                                                <strong>Description:</strong> {surcharge['description']}<br />
                                                                <strong>Amount:</strong> {selectedSurchargeFor === 'dme' ? surcharge['amount'] : surcharge['amount_cl']}<br />
                                                                <strong>Qty:</strong> {surcharge['qty'] || 1}<br />
                                                                <strong>Manually added?:</strong> {surcharge['is_manually_entered'] ? 'Yes' : 'No'}<br />
                                                                {index !== 0 ? <hr/> : null}
                                                            </p>
                                                        </React.Fragment>
                                                    );
                                                })
                                        }
                                    </UncontrolledTooltip>
                                </React.Fragment>
                                : ''}
                        </td>
                        <td className='text-center'>{price['insurance_fee'] ? `$${price['insurance_fee'].toFixed(2)}` : ''}</td>
                        <td>
                            ${(price['client_mu_1_minimum_values'] * (1 + price['parent_markup_percent'])).toFixed(2)}
                            &nbsp;&nbsp;&nbsp;
                            <i className="fa fa-copy" onClick={() => this.copyToClipBoard((price['client_mu_1_minimum_values'] * (1 + price['parent_markup_percent'])).toFixed(2))}></i>
                        </td>
                        <td>{moment().add(Math.ceil(price['eta_in_hour'] / 24), 'd').format('YYYY-MM-DD')} ({price['eta']})</td>
                        <td>
                            <Button
                                className="btn-sm btn-icon m-auto"
                                color={selectedPricing === price['cost_id'] ? 'success' : 'primary'}
                                disabled={selectedPricing === price['cost_id']}
                                onClick={() => this.handleOnClickPricing(price)}
                            >
                                <i className='fa fa-check'/>
                            </Button>
                        </td>
                    </tr>
                );
            });

        const handleChangeAddressType = (e, type) => {
            const { formInputs } = this.state;
            if (type == 'pu')
                formInputs['pu_Address_Type'] = e.target.value;
            else
                formInputs['de_To_AddressType'] =  e.target.value;
            this.setState({  formInputs });
        };

        const handleChangeTailLift = (e, type) => {
            const { formInputs } = this.state;
            if (type == 'pu')
                formInputs['b_booking_tail_lift_pickup'] = e.target.value;
            else
                formInputs['b_booking_tail_lift_deliver'] = e.target.value;
            this.setState({  formInputs });
        };

        const handleChangeNoOfAssist = (e, type) => {
            const { formInputs } = this.state;
            if (type == 'pu')
                formInputs['pu_no_of_assists'] = e.target.value;
            else
                formInputs['de_no_of_assists'] = e.target.value;
            this.setState({  formInputs });
        };

        return (
            <React.Fragment>
                <Popover
                    className="quick-quote panel-2"
                    id="quickQuotePopover"
                    isOpen={isOpen}
                    target="Popover"
                    placement="bottom"
                    hideArrow={false}
                    onToggle={() => { setIsOpen(false); }}>
                    <PopoverBody>
                        <LoadingOverlay
                            active={isGettingQuickQuote}
                            spinner
                            text='Loading...'
                        >
                            <div className="popover-close m-3" onClick={() => setIsOpen(false)}>
                                <i className="fa fa-times p-1"></i>
                            </div>
                            <form className="quick-quote-form px-3 dme-form-sm" onSubmit={(e) => this.onClickGetQuote(e)}>
                                <div className="flex flex-col mb-3">
                                    <div className="flex flex-col w-half">
                                        <label className='form-label'>Customer: <span className='required'/></label>
                                        <Select
                                            className="select grow px-3"
                                            value={customer}
                                            onChange={(e) => this.handleChangeCustomer(e, 'customer')}
                                            options={clientOptionsList}
                                            placeholder='Select your customer'
                                            openMenuOnClick={true}
                                            required="required"
                                            tabIndex='1'
                                            isDisabled={clientname !== 'dme' && clientname !== 'Gebrüder Weiss'}
                                        />
                                    </div>
                                </div>
                                <div className="flex mt-3 ">
                                    <div className='flex flex-col mr-3 group pb-3 w-half'>
                                        <div className="flex flex-col">
                                            <label className='form-label'>Pickup address: <span className='required'/></label>
                                            <Select
                                                className="select grow px-3"
                                                value={puSuburb}
                                                onChange={(e) => this.handleChangeSuburb(e, 'puSuburb')}
                                                onInputChange={debounce((e) => this.handleInputChangeSuburb(e, 'puSuburb'), 500)}
                                                onFocus={() => this.handleFocusSuburb('puSuburb')}
                                                options={puAddressOptions}
                                                placeholder='select your suburb'
                                                openMenuOnClick={true}
                                                filterOption={(options) => {
                                                    // Do no filtering, just return all options
                                                    return options;
                                                }}
                                                required="required"
                                                tabIndex='1'
                                            />
                                        </div>
                                        <div className="flex justify-stretch">
                                            <div className="flex flex-col w-half">
                                                <label className='form-label'>Postal Code:</label>
                                                <div className='px-3'>
                                                    <input className='form-control mb-0' disabled value={formInputs['pu_Address_PostalCode'] || ''}></input>
                                                </div>
                                            </div>
                                            <div className="flex flex-col w-half">
                                                <label className='form-label'>State:</label>
                                                <div className='px-3'>
                                                    <input className='form-control mb-0' disabled value={formInputs['pu_Address_State'] || ''}></input>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex justify-stretch">
                                            <div className="flex flex-col w-half">
                                                <label className='form-label'>Address Type:</label>
                                                <div className='px-3'>
                                                    <select
                                                        className='form-control'
                                                        name="pu_Address_Type"
                                                        onChange={(e) => this.handleChangeAddressTypePreValue(e, 'pu')}
                                                        value={preValue['pu_Address_Type']}
                                                        required={isGWSubClientWithId(formInputs['customer_id']) ? true : false}
                                                    >
                                                        <option value="" disabled hidden></option>
                                                        <option value='business'>Business</option>
                                                        <option value='residential'>Residential</option>
                                                    </select>
                                                </div>

                                            </div>
                                            <div className="flex flex-col w-half">
                                                <label className='form-label'>Tail Lift: </label>
                                                <div className='px-3'>
                                                    <select
                                                        className='form-control'
                                                        name="b_booking_tail_lift_pickup"
                                                        onChange={(e) => this.handleChangeTailLiftPreValue(e, 'pu')}
                                                        value={preValue['b_booking_tail_lift_pickup']}
                                                    >
                                                        <option value="" disabled hidden></option>
                                                        <option value='0'>Not Required</option>
                                                        <option value='1'>Required</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col group pb-3 w-half">
                                        <div className='flex flex-col'>
                                            <label className='form-label'>Delivery address: <span className='required'/></label>
                                            <Select
                                                className="select grow px-3"
                                                value={deToSuburb}
                                                onChange={(e) => this.handleChangeSuburb(e, 'deToSuburb')}
                                                onInputChange={debounce((e) => this.handleInputChangeSuburb(e, 'deToSuburb'), 500)}
                                                focus={() => this.handleFocusSuburb('deToSuburb')}
                                                options={deToAddressOptions}
                                                placeholder='select your suburb'
                                                openMenuOnClick={true}
                                                filterOption={(options) => {
                                                    // Do no filtering, just return all options
                                                    return options;
                                                }}
                                                required="required"
                                                tabIndex='2'
                                            />
                                        </div>
                                        <div className="flex justify-stretch">
                                            <div className="flex flex-col w-half">
                                                <label className='form-label'>Postal Code:</label>
                                                <div className='px-3'>
                                                    <input className='form-control px-3 mb-0' disabled value={formInputs['de_To_Address_PostalCode'] || ''}></input>
                                                </div>
                                            </div>
                                            <div className="flex flex-col w-half">
                                                <label className='form-label'>State:</label>
                                                <div className='px-3'>
                                                    <input className='form-control mb-0' disabled value={formInputs['de_To_Address_State'] || ''}></input>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex justify-stretch">
                                            <div className="flex flex-col w-half">
                                                <label className='form-label'>Address Type:</label>
                                                <div className='px-3'>
                                                    <select
                                                        className='form-control'
                                                        name="de_To_AddressType"
                                                        onChange={(e) => this.handleChangeAddressTypePreValue(e, 'de')}
                                                        value={preValue['de_To_AddressType']}
                                                        required={isGWSubClientWithId(formInputs['customer_id']) ? true : false}
                                                    >
                                                        <option value="" disabled hidden></option>
                                                        <option value='business'>Business</option>
                                                        <option value='residential'>Residential</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="flex flex-col w-half">
                                                <label className='form-label'>Tail Lift:</label>
                                                <div className='px-3'>
                                                    <select
                                                        className='form-control'
                                                        name="b_booking_tail_lift_deliver"
                                                        onChange={(e) => this.handleChangeTailLiftPreValue(e, 'de')}
                                                        value={preValue['b_booking_tail_lift_deliver']}
                                                    >
                                                        <option value="" disabled hidden></option>
                                                        <option value='0'>Not Required</option>
                                                        <option value='1'>Required</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row quote-detail-infos hidden">
                                    <div className="form-group px-1">
                                        <label>
                                            <p><strong>Address Type: </strong></p>
                                        </label>
                                        <select
                                            className='form-control'
                                            name="pu_Address_Type"
                                            onChange={(e) => handleChangeAddressType(e, 'pu')}
                                            value={formInputs['pu_Address_Type'] ? formInputs['pu_Address_Type'] : ''}
                                            style={{ borderColor:this.state.isInvalid && formInputs['pu_Address_Type'] == '' ? '#c00000' : '',
                                                borderWidth:this.state.isInvalid && formInputs['pu_Address_Type'] == '' ? '2px' : ''
                                            }}
                                        >
                                            <option value="" disabled hidden>--- Address type ---</option>
                                            <option value='business'>Business</option>
                                            <option value='residential'>Residential</option>
                                        </select>
                                    </div>
                                    <div className="form-group px-1">
                                        <label>
                                            <p><strong>Tail Lift: </strong></p>
                                            <select
                                                className='form-control'
                                                name="b_booking_tail_lift_pickup"
                                                onChange={(e) => handleChangeTailLift(e, 'pu')}
                                                value={formInputs['b_booking_tail_lift_pickup'] ? formInputs['b_booking_tail_lift_pickup'] : ''}
                                            >
                                                <option value='0'>Not Required</option>
                                                <option value='1'>Required</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div className="form-group px-1">
                                        <label>
                                            <p><strong>No of men to assist: </strong></p>
                                            <select
                                                className='form-control'
                                                name="pu_no_of_assists"
                                                onChange={(e) => handleChangeNoOfAssist(e,'pu')}
                                                style={{ borderColor:this.state.isInvalid && formInputs['pu_no_of_assists'] == '' ? '#c00000' : '',
                                                    borderWidth:this.state.isInvalid && formInputs['pu_no_of_assists'] == '' ? '2px' : ''
                                                }}
                                                value={formInputs['pu_no_of_assists'] ? formInputs['pu_no_of_assists'] : ''}
                                            >
                                                <option value="" disabled hidden>--- Number of men to assist ---</option>
                                                <option value='0'>0</option>
                                                <option value='1'>1 & Customer will assist load</option>
                                                <option value='2'>2</option>
                                                <option value='3'>3</option>
                                                <option value='4'>4</option>
                                                <option value='5'>5</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div className="form-group px-1" style={{ marginRight:25 }}>
                                    </div>
                                    <div className="form-group px-1">
                                        <label>
                                            <p><strong>Address Type: </strong></p>
                                            <select
                                                className='form-control'
                                                name="de_To_AddressType"
                                                onChange={(e) => handleChangeAddressType(e, 'de')}
                                                value={formInputs['de_To_AddressType'] ? formInputs['de_To_AddressType'] : ''}
                                                style={{ borderColor:this.state.isInvalid && formInputs['de_To_AddressType'] == '' ? '#c00000' : '',
                                                    borderWidth:this.state.isInvalid && formInputs['pu_no_of_assists'] == '' ? '2px' : ''
                                                }}
                                            >
                                                <option value="" disabled hidden>--- Address type ---</option>
                                                <option value='business'>Business</option>
                                                <option value='residential'>Residential</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div className="form-group px-1">
                                        <label>
                                            <p><strong>Tail Lift: </strong></p>
                                            <select
                                                className='form-control'
                                                name="b_booking_tail_lift_deliver"
                                                onChange={(e) => handleChangeTailLift(e, 'de')}
                                                value={formInputs['b_booking_tail_lift_deliver'] ? formInputs['b_booking_tail_lift_deliver'] : ''}
                                            >
                                                <option value='0'>Not Required</option>
                                                <option value='1'>Required</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div className="form-group px-1">
                                        <label>
                                            <p><strong>No of men to assist: </strong></p>
                                            <select
                                                className='form-control'
                                                name="de_no_of_assists"
                                                onChange={(e) => handleChangeNoOfAssist(e, 'de')}
                                                style={{ borderColor:this.state.isInvalid && formInputs['de_no_of_assists'] == '' ? '#c00000' : '',
                                                    borderWidth:this.state.isInvalid && formInputs['de_no_of_assists'] == '' ? '2px' : ''
                                                }}
                                                value={formInputs['de_no_of_assists'] ? formInputs['de_no_of_assists'] : ''}
                                            >
                                                <option value="" disabled hidden>--- Number of men to assist ---</option>
                                                <option value='0'>0</option>
                                                <option value='1'>1 & Customer will assist load</option>
                                                <option value='2'>2</option>
                                                <option value='3'>3</option>
                                                <option value='4'>4</option>
                                                <option value='5'>5</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div className="col-md-1">
                                    </div>
                                </div>
                                <div className="flex flex-col group pb-3 my-3">
                                    <table className="p-3 booking-lines-table">
                                        <thead>
                                            <th className="form-label text-center">Type<span className="required"/></th>
                                            <th className="form-label text-center">Quantity<span className="required"/></th>
                                            <th className="form-label text-center">Unit<span className="required"/></th>
                                            <th className="form-label text-center">Length<span className="required"/></th>
                                            <th className="form-label text-center">Width<span className="required"/></th>
                                            <th className="form-label text-center">Height:<span className="required"/></th>
                                            <th className="form-label text-center">Weight Unit:<span className="required"/></th>
                                            <th className="form-label text-center">Weight(each):<span className="required"/></th>
                                            <th className="form-label text-center"></th>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredLines.map((line, index) => (
                                                    <tr key={index}>
                                                        <td className='px-3'>
                                                            <select
                                                                className='form-control'
                                                                name={'e_type_of_packaging' + index}
                                                                onChange={(e) => this.onInputChange(e, index, 'e_type_of_packaging')}
                                                                value={line.e_type_of_packaging}
                                                                key={'e_type_of_packaging' + index}
                                                                required="required"
                                                                tabIndex={10 + index * 10 + 0}
                                                            >
                                                                <option value="Carton">Carton</option>
                                                                <option value="Pallet">Pallet</option>
                                                                <option value="Skid">Skid</option>
                                                            </select>
                                                        </td>
                                                        <td className='px-3'>
                                                            <input
                                                                className='form-control'
                                                                name={'e_qty' + index}
                                                                id={'e_qty' + index}
                                                                value={line.e_qty}
                                                                key={'e_qty' + index}
                                                                onChange={(e) => this.onInputChange(e, index, 'e_qty')}
                                                                required
                                                                type='number'
                                                                tabIndex={10 + index * 10 + 1}
                                                            />
                                                        </td>
                                                        <td className='px-3'>
                                                            <select
                                                                className='form-control'
                                                                name={'e_dimUOM' + index}
                                                                onChange={(e) => this.onInputChange(e, index, 'e_dimUOM')}
                                                                value={line.e_dimUOM}
                                                                key={'e_dimUOM' + index}
                                                                required
                                                                tabIndex={10 + index * 10 + 2}
                                                            >
                                                                <option value="m">m</option>
                                                                <option value="cm">cm</option>
                                                                <option value="mm">mm</option>
                                                            </select>
                                                        </td>
                                                        <td className='px-3'>
                                                            <input
                                                                className='form-control'
                                                                name={'e_dimLength' + index}
                                                                id={'e_dimLength' + index}
                                                                placeholder="" value={line.e_dimLength}
                                                                key={'e_dimLength' + index}
                                                                onChange={(e) => this.onInputChange(e, index, 'e_dimLength')}
                                                                required
                                                                type='number'
                                                                step='0.01'
                                                                tabIndex={10 + index * 10 + 3}
                                                            />
                                                        </td>
                                                        <td className='px-3'>
                                                            <input
                                                                className='form-control'
                                                                name={'e_dimWidth' + index}
                                                                id={'e_dimWidth' + index}
                                                                placeholder=""
                                                                value={line.e_dimWidth}
                                                                key={'e_dimWidth' + index}
                                                                onChange={(e) => this.onInputChange(e, index, 'e_dimWidth')}
                                                                required
                                                                type='number'
                                                                step='0.01'
                                                                tabIndex={10 + index * 10 + 4}
                                                            />
                                                        </td>
                                                        <td className='px-3'>
                                                            <input
                                                                className='form-control'
                                                                name={'e_dimHeight' + index}
                                                                id={'e_dimHeight' + index}
                                                                placeholder=""
                                                                value={line.e_dimHeight}
                                                                key={'e_dimHeight' + index}
                                                                onChange={(e) => this.onInputChange(e, index, 'e_dimHeight')}
                                                                required
                                                                type='number'
                                                                step='0.01'
                                                                tabIndex={10 + index * 10 + 5}
                                                            />
                                                        </td>
                                                        <td className='px-3'>
                                                            <select
                                                                className='form-control'
                                                                name={'e_weightUOM' + index}
                                                                onChange={(e) => this.onInputChange(e, index, 'e_weightUOM')}
                                                                value={line.e_weightUOM}
                                                                key={'e_weightUOM' + index}
                                                                required
                                                                tabIndex={10 + index * 10 + 6}
                                                            >
                                                                <option value="kg">kg</option>
                                                                <option value="gram">gram</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                className='form-control'
                                                                name={'e_weightPerEach' + index}
                                                                id={'e_weightPerEach' + index}
                                                                placeholder="" value={line.e_weightPerEach}
                                                                key={'e_weightPerEach' + index}
                                                                onChange={(e) => this.onInputChange(e, index, 'e_weightPerEach')}
                                                                required
                                                                type='number'
                                                                step='0.01'
                                                                tabIndex={10 + index * 10 + 7}
                                                            />
                                                        </td>
                                                        <td className='flex flex-col flex-none justify-center items-center'>
                                                            {
                                                                filteredLines.length === 1 ? 
                                                                    (<div className="mb-3 invisible text-danger" key={'cancel' + index} tabIndex={10 + index * 10 + 8}>
                                                                        <div className='btn btn-icon'><i className="fa fa-trash p-2"></i></div>
                                                                    </div>)
                                                                    :
                                                                    (<div className='mb-3' onClick={() => this.onCancel(index)} key={'cancel' + index} tabIndex={10 + index * 10 + 8}>
                                                                        <div className='btn btn-icon text-danger'><i className="fa fa-trash p-2"></i></div>
                                                                    </div>)
                                                            }
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <div className="flex justify-start px-3">
                                        <button className="btn btn-primary" type="button" onClick={() => this.onClickAddPackage()} tabIndex={10 + lines.length * 10 + 9}>
                                            + Add Package
                                        </button>
                                    </div>
                                </div>
                            
                                {
                                    !isGWSubClientWithId(formInputs['customer_id']) &&
                                    (<div className="flex justify-start mb-3 group">
                                        <div className='px-3 py-2 flex justify-content-center align-items-center'>
                                            <label className='form-label'>Insurance Service: </label>
                                            <input
                                                className='form-control'
                                                name='insurance_service'
                                                checked={formInputs['insurance_service']}
                                                onChange={(e) => this.setState({ formInputs: { ...formInputs, insurance_service: e.target.checked } })}
                                                type='checkbox'
                                            />
                                        </div>
                                        <div className='px-3 py-2 flex justify-content-center align-items-center'>
                                            <label className='form-label value-of-goods'>Value of Goods: {formInputs['insurance_service'] && <span className='required'/>}</label>
                                            <input
                                                className='form-control'
                                                name='client_sales_total'
                                                value={formInputs['client_sales_total']}
                                                type='number'
                                                step="0.1"
                                                min={500}
                                                onChange={(e) => this.setState({ formInputs: { ...formInputs, client_sales_total: e.target.value === '' ? null : Number(e.target.value) } })}
                                                required={formInputs['insurance_service']}
                                            />
                                        </div>
                                    </div>)
                                }
    
                                {quickPricings.length > 0 ?
                                    <section>
                                        <div className="quick-quote-tabs">
                                            <div className="row">
                                                <div className="tabs">
                                                    <div className="tab-button-outer mb-3">
                                                        <ul id="tab-button">
                                                            <li>
                                                                <a className={activeTabInd === 0 ? 'btn btn-primary' : 'btn btn-default'} onClick={(e) => this.onSwitchTab(e, 0)}>Send As Is</a>
                                                            </li>
                                                            <li>
                                                                <a className={activeTabInd === 1 ? 'btn btn-primary' : 'btn btn-default'} onClick={(e) => this.onSwitchTab(e, 1)}>Auto Repack</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    {/* <div className="tab-select-outer none">
                                                        <select id="tab-select">
                                                            <option value="#tab01">Original</option>
                                                            <option value="#tab02">Auto Repack</option>
                                                        </select>
                                                    </div> */}
                                                    <div id="tab01" className={activeTabInd === 0 ? 'selected' : 'none'}>
                                                        <div className="row quote-result">
                                                            <table className="table table-hover sortable fixed_headers">
                                                                <thead className='bg-gradient'>
                                                                    <tr>
                                                                        <th>Freight Provider</th>
                                                                        <th>Service (Vehicle)</th>
                                                                        <th>Cost $</th>
                                                                        <th>Fuel Levy %</th>
                                                                        <th>Fuel Levy $</th>
                                                                        <th>Extra $</th>
                                                                        <th>Insurance $</th>
                                                                        <th>Total $ (ex. GST)</th>
                                                                        <th onClick={() => this.onClickColumn('fastest')}>ETA (click & sort)</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {originalPricings}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div id="tab02" className={activeTabInd === 1 ? 'selected' : 'none'}>
                                                        <div className="row quote-result">
                                                            <table className="table table-hover sortable fixed_headers">
                                                                <thead className='bg-gradient'>
                                                                    <tr>
                                                                        <th>Freight Provider</th>
                                                                        <th>Service (Vehicle)</th>
                                                                        <th>Cost $</th>
                                                                        <th>Fuel Levy %</th>
                                                                        <th>Fuel Levy $</th>
                                                                        <th>Extra $</th>
                                                                        <th>Insurance $</th>
                                                                        <th>Total $ (ex. GST)</th>
                                                                        <th onClick={() => this.onClickColumn('fastest')}>ETA (click & sort)</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {autoPricings}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
    
                                    </section>
                                    : null
                                }
                                <div className="d-flex justify-content-between">
                                    <button className="btn btn-success" type="button" tabIndex={10 + lines.length * 10 + 10} onClick={() => this.handleCreateBooking()}>
                                        Create Booking
                                    </button>
                                    <button className="btn btn-primary mr-3" type="submit" tabIndex={10 + lines.length * 10 + 10 + 1}>
                                        Get Quote
                                    </button>
                                </div>
                            </form>
                        </LoadingOverlay>
                    </PopoverBody>
                </Popover>
                <ExtremelyLargeItemAlertModal
                    isOpen={extraLargeItemModal}
                    centered={true}
                    handleClose={() => this.closeExtraLargeItemErrorModal()}
                    booking={this.reflectPreValueToBooking(formInputs, preValue)}
                    lines={lines}
                />
                <ConfirmModal
                    isOpen={this.state.isShowConfirmModal}
                    onOk={() => this.onClickConfirmBtn()}
                    onCancel={() => this.onClickCancelBtn()}
                    title={'Booking is created successfully'}
                    text={'Would you like to view the booking details?'}
                    okBtnName={'Cancel'}
                    cancelBtnName={'Go To Created Booking'}
                />
            </React.Fragment>
        );
        
    }
}

const mapStateToProps = (state) => {
    return {
        clientname: state.auth.clientname,
        quickPricings: state.extra.quickPricings,
        quickPricingLines: state.extra.quickPricingLines,
        puAddresses: state.elasticsearch.puAddresses,
        deToAddresses: state.elasticsearch.deToAddresses,
        errorMessage: state.extra.errorMessage,
        bookingErrorMessage: state.booking.errorMessage,
        booking: state.booking.booking,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAddressesWithPrefix: (src, suburbPrefix, postalCodePrefix) => dispatch(getAddressesWithPrefix(src, suburbPrefix, postalCodePrefix)),
        getQuickPricing: (data) => dispatch(getQuickPricing(data)),
        setErrorMessage: (message) => dispatch(setErrorMessage(message)),
        setQuickQuoteBookingData: (data) => dispatch(setQuickQuoteBookingData(data)),
        saveBooking: (booking, line) => dispatch(saveBooking(booking, line)),
        resetQuickPricings: () => dispatch(resetQuickPricings()),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuickQuotePopover));



// WEBPACK FOOTER //
// ./src/components/Popovers/QuickQuotePopover.js